// import React, { useCallback, useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import ClipLoader from 'react-spinners/ClipLoader';
// import { FaRedo } from 'react-icons/fa';
// import 'react-toastify/dist/ReactToastify.css';
// import './EmailUpdateVerification.css';
// import { BASE_URL } from '../../Services/Services';

// const EmailUpdateVerification = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showSuccessMessage, setShowSuccessMessage] = useState(false);
//   const [emailToken, setEmailToken] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const urlParams = new URLSearchParams(location.search);
//     const token = urlParams.get('emailToken');
//     setEmailToken(token);
//   }, [location]);

//   useEffect(() => {
//     if (emailToken) {
//       verifyEmail();
//     } else {
//        setLoading(false);
//     }
//   }, [emailToken, verifyEmail]);

//   const verifyEmail = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${BASE_URL}/verify-email?emailToken=${emailToken}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       const result = await response.json();

//       toast.dismiss();
//       if (result?.success) {
//         setShowSuccessMessage(true);
//         toast.success('Your new email has been verified! Please login with your new email!', { autoClose: 4000 });
//         navigate('/login');

//       } else {
//         setError('Email verification failed. Please try again.');
//         toast.error('Email verification failed. Please try again.');
//       }
//     } catch (err) {
//       toast.dismiss();
//       setError('Something went wrong. Please try again.');
//       toast.error('Something went wrong. Please try again.');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   }, [emailToken, navigate]);


//   const handleRetry = () => {
//     setError(null);
//     setShowSuccessMessage(false);
//     setLoading(true);
//     verifyEmail();
//   };



//   return (
//     <div className="main-login-container">
//       {loading && (
//         <div className="loader-overlay">
//           <ClipLoader color="#fff" loading={loading} size={50} />
//         </div>
//       )}

//       {showSuccessMessage && !loading && (
//         <div className="emailupdate-popup-overlay">
//           <div className="emailupdate-popup-content">
//             <p>Your new email is verified, you will be logged out now, please login with your new email.</p>
//           </div>
//         </div>
//       )}

//       {error && (
//         <div className="error-message-container">
//           <p className="error-message">{error}</p>
//           <button className="retry-button" onClick={handleRetry}>
//             <FaRedo size={20} style={{ marginRight: '8px' }} /> Retry
//           </button>
//         </div>
//       )}

//     </div>
//   );
// };

// export default EmailUpdateVerification;

import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import { FaRedo } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';
import './EmailUpdateVerification.css';
import { BASE_URL } from '../../Services/Services';

const EmailUpdateVerification = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [emailToken, setEmailToken] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('emailToken');
    setEmailToken(token);
  }, [location]);


  const verifyEmail = useCallback(async () => {
    toast.dismiss();

    try {
      setLoading(true);
            const response = await fetch(`${BASE_URL}/verify-email?emailToken=${emailToken}`, {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (result?.success) {
        setShowSuccessMessage(true);
        toast.dismiss();

        toast.success('Your new email has been verified! Please login with your new email!', {autoClose: 4000});
             navigate('/login');

      } else {
        setError('Email verification failed. Please try again.');
        toast.error('Email verification failed. Please try again.');
      }
    } catch (err) {
      toast.dismiss();

      setError('Something went wrong. Please try again.');
      toast.error('Something went wrong. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  },[emailToken, navigate]);


  const handleRetry = () => {
    setError(null);
    setShowSuccessMessage(false);
    setLoading(true);
    verifyEmail();
  };

  useEffect(() => {
    if (emailToken) {
      verifyEmail();
    } else {

      setLoading(false);
    }
  }, [emailToken, verifyEmail]);


  return (
    <div className="main-login-container">
      {loading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={loading} size={50} />
        </div>
      )}

      {showSuccessMessage && !loading && (
        <div className="emailupdate-popup-overlay">
          <div className="emailupdate-popup-content">
            <p>Your new email is verified, you will be logged out now, please login with your new email.</p>
          </div>
        </div>
      )}

      {error && (
        <div className="error-message-container">
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={handleRetry}>
            <FaRedo size={20} style={{ marginRight: '8px' }} /> Retry
          </button>
        </div>
      )}

    </div>
  );
};

export default EmailUpdateVerification;
